import { ITimeOffActions, TimeOffContext } from './actions.types';
import { ITimeOffPolicyData, ITimeOffTemplateData } from '@/models';
import { ITimeOffExportBalancesParams } from '@/services';

export const actions: ITimeOffActions = {
  fetchTimeOffTypes(context: TimeOffContext): Promise<void> {
    return this.$services.timeOff.fetchTimeOffTypes().then(data => {
      context.commit('SET_TIME_OFF_TYPES', data);
    });
  },

  fetchAvailableTimeOffTypes(context: TimeOffContext): Promise<void> {
    return this.$services.timeOff.fetchAvailableTimeOffTypes().then(data => {
      context.commit('SET_TIME_OFF_TYPES', data);
    });
  },

  fetchTimeOffTemplates(context: TimeOffContext): Promise<void> {
    return this.$services.timeOff.fetchTimeOffTemplates().then(data => {
      context.commit('SET_TIME_OFF_TEMPLATES', data);
    });
  },

  fetchTimeOffTemplate(
    context: TimeOffContext,
    payload: number
  ): Promise<void> {
    return this.$services.timeOff
      .fetchTimeOffTemplate(payload)
      .then((timeOffTemplate: ITimeOffTemplateData) => {
        const index = context.state.templates.findIndex(
          (v: ITimeOffTemplateData) => v.id === timeOffTemplate.id
        );
        if (index === -1) {
          context.commit('ADD_TIME_OFF_TEMPLATE', timeOffTemplate);
        } else {
          context.commit('UPDATE_TIME_OFF_TEMPLATE', timeOffTemplate);
        }
      });
  },

  fetchTimeOffPolicies(context: TimeOffContext): Promise<void> {
    return this.$services.timeOff.fetchTimeOffPolicies().then(data => {
      context.commit('SET_TIME_OFF_POLICIES', data);
    });
  },

  createTimeOffPolicy(
    context: TimeOffContext,
    payload: ITimeOffPolicyData
  ): Promise<void> {
    return this.$services.timeOff
      .createTimeOffPolicy(payload)
      .then((timeOff: ITimeOffPolicyData) =>
        context.commit('ADD_TIME_OFF_POLICY', timeOff)
      );
  },

  updateTimeOffPolicy(
    context: TimeOffContext,
    payload: ITimeOffPolicyData
  ): Promise<void> {
    return this.$services.timeOff
      .updateTimeOffPolicy(payload)
      .then((timeOff: ITimeOffPolicyData) => {
        const index = context.state.timeOffPolicies.findIndex(
          (v: ITimeOffPolicyData) => v.id === timeOff.id
        );
        if (index === -1) {
          context.commit('ADD_TIME_OFF_POLICY', timeOff);
        } else {
          context.commit('UPDATE_TIME_OFF_POLICY', timeOff);
        }
      });
  },

  deleteTimeOffPolicy(context: TimeOffContext, payload: number): Promise<void> {
    return this.$services.timeOff.deleteTimeOffPolicy(payload).then(() => {
      context.commit('REMOVE_TIME_OFF_POLICY', payload);
    });
  },

  rollOverEntitlement(context: TimeOffContext): Promise<void> {
    return this.$services.timeOff.rollOverEntitlement();
  },

  incrementEntitlementYears(
    context: TimeOffContext,
    payload: number
  ): Promise<void> {
    return this.$services.timeOff
      .incrementEntitlementYears(payload)
      .then(data => {
        context.commit('SET_TIME_OFF_POLICIES', data);
      });
  },

  exportTimeOffBalances(
    context: TimeOffContext,
    params: ITimeOffExportBalancesParams
  ): Promise<Blob> {
    return this.$services.timeOff
      .exportTimeOffBalances(params)
      .then(data => data);
  }
};
